<div
  class="body"
  [ngClass]="{
    'dark-theme': (_theme$ | async) === 'dark-theme',
    'light-theme': (_theme$ | async) === 'light-theme',
    'paper-theme': (_theme$ | async) === 'paper-theme',
    'canvas-active-body': _isCanvasRoute,
  }"
>
  @if (_showSplash) {
    <ddc-splash-screen (splashComplete)="onSplashComplete()"></ddc-splash-screen>
  }
  @if (_authResolved) {
    @if (!_maintenanceMode) {
      @if (_showNavbar) {
        <ddc-navbar class="main-navbar"></ddc-navbar>
      } @else {
        <ddc-public-navbar class="main-navbar"></ddc-public-navbar>
      }
    }
  }
  <div class="route-container" [class.canvas-active]="_isCanvasRoute">
    <router-outlet></router-outlet>
  </div>
  @if (_authResolved) {
    @if (!_maintenanceMode) {
      @if (_showNavbar && !_isCanvasRoute) {
        <footer>
          <ddc-footer class="ddc-footer-main"></ddc-footer>
        </footer>
        <ddc-bottom-navbar
          [_DefaultProfilePic]="_DefaultProfilePic"
          [_hasPic]="_hasPic"
          [_isAdmin]="_isAdmin"
          [_isProfilePicLoading]="_isProfilePicLoading"
          [_isVerified]="_isVerified"
          [_subscription]="_subscription"
          [_theme]="_theme$ | async"
          [_username]="_username"
          [_userProfilePic]="_userProfilePic"
        ></ddc-bottom-navbar>
      }
    }
  }
</div>
